export default "__VITE_ASSET__CaWGEZjQ__"